// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"0b1508f9","361":"55dc2c1f","433":"5f8d91b4","688":"a220faa8","724":"8dd5341e","931":"42cc0f23"}[chunkId] + ".chunk.css";
};